import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import styles from './ActivityTimeline.module.css';

const buildTimelinePayload = (backendData) => {
  const grouped = {};

  backendData.forEach((item) => {
    const dateObj = new Date(item.timeStamp);

    const dateLabel = dateObj
      .toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })
      .replace(',', '')
      .replace(' ', '/');

    const time = dateObj
      .toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      })
      .toLowerCase();

    if (!grouped[dateLabel]) {
      grouped[dateLabel] = [];
    }

    if (item.details?.changes?.length) {
      item.details.changes.forEach((change) => {
        grouped[dateLabel].push({
          time,
          username: item.username,
          summary: change,
          rawDate: dateObj,
        });
      });
    } else {
      grouped[dateLabel].push({
        time,
        username: item.username,
        summary: item.summary,
        rawDate: dateObj,
      });
    }
  });

  let result = Object.entries(grouped).map(([dateLabel, events]) => ({
    dateLabel,
    events: events
      .sort((a, b) => b.rawDate - a.rawDate)
      .map(({ time, username, summary }) => ({
        time,
        username,
        summary,
      })),
  }));

  result.sort((a, b) => {
    const aDate = new Date(a.events[0].rawDate || a.dateLabel);
    const bDate = new Date(b.events[0].rawDate || b.dateLabel);
    return bDate - aDate;
  });

  return result;
};

export default function ActivityTimeline({ data }) {
  const items = buildTimelinePayload(data);
  return (
    <Box className={styles.wrapper}>
      <span className={styles.line} />

      {items.map((group, gIdx) => (
        <Box key={gIdx} className={styles.group}>
          <Typography className={styles.dateLabel}>{group.dateLabel}</Typography>

          <Box className={styles.events}>
            {group.events.map((ev, eIdx) => (
              <Box key={eIdx} className={styles.eventRow}>
                <Typography className={styles.time}>{ev.time}</Typography>

                <Box className={styles.timelineCol}>
                  <span className={styles.dot} />
                </Box>

                <Box className={styles.texts}>
                  <Typography className={styles.title}>{ev.username}</Typography>
                  <Typography className={styles.subtitle}>{ev.summary}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

ActivityTimeline.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      timeStamp: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
      summary: PropTypes.string.isRequired,
    })
  ).isRequired,
};
